(function () {
  function isHalalContext() {
    try {
      return new URLSearchParams(window.location.search).get('ref') === 'halal-menu';
    } catch (e) {
      return false;
    }
  }

  function syncHalalForms() {
    var on = isHalalContext();

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      // data-halal-flag marks inputs WE own, so we never delete a Note
      // field the theme or another app put there.
      var existing = form.querySelector('input[name="properties[Note]"][data-halal-flag]');

      if (on && !existing) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Note]';
        input.value = 'Halal';
        input.setAttribute('data-halal-flag', '');
        form.appendChild(input);
      } else if (!on && existing) {
        existing.remove();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', syncHalalForms);
  document.addEventListener('cart:refresh', syncHalalForms);
  document.addEventListener('variant:change', syncHalalForms);
})();